import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { ActivityDto } from '@api/models/activity/ActivityDto';
import { activityService } from '@api/services/services';

export interface ActivityListFilter extends ListFilter {
  riskRequired?: boolean;
  certificateRequired?: boolean;
  state?: EntityState;
}

export type ActivityListState = ListType<ActivityDto, ActivityListFilter>;

const initialState: ActivityListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const activityListSlice = listSlice({
  name: 'activityList',
  initialState,
});

export const selectActivityList = (state: RootState) => state.activityList;
export const activityListActions = activityListSlice.actions;

export const getActivityList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectActivityList(storeState);

  const handleGetData = (size: number) => {
    return activityService.query(
      {
        q: data.query.q,
        riskRequired: data.query.riskRequired,
        certificateRequired: data.query.certificateRequired,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken as any }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: activityListActions,
    getData: handleGetData,
  });
};
